var $buoop = {
		l: 'de',
		test: false,
		text_xx: "",
		newwindow: true
};
